import { Toaster as SonnerToaster } from 'sonner';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  position?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
  richColors?: boolean;
  closeButton?: boolean;
};

export const Toaster: FC<Props> = ({ position = 'top-right', richColors = true, closeButton = true }) => {
  const { t } = useTranslation('common');

  // Screen reader labels: sonner defaults to English regardless of the interface language
  return (
    <SonnerToaster
      position={position}
      richColors={richColors}
      closeButton={closeButton}
      containerAriaLabel={t('notifications')}
      toastOptions={{ closeButtonAriaLabel: t('closeNotification') }}
    />
  );
};
